import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import { ThemeToggle, CartBadge } from '../ui';

const navClass = ({ isActive }) =>
  isActive 
    ? 'text-light-accent-red dark:text-brand-accent-red' 
    : 'text-light-text-primary dark:text-brand-text-primary hover:text-light-accent-red dark:hover:text-brand-accent-red transition';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const {
    state: { items },
  } = useCart();
  const cartCount = items.reduce((sum, i) => sum + i.qty, 0);

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };
  
  return (
    <header 
      id="app-navbar" 
      className="sticky top-0 left-0 w-full z-20 bg-white dark:bg-brand-surface border-b border-light-border-default dark:border-brand-border-default shadow-sm transition-colors duration-200"
    >
      <div className="flex justify-between items-center px-4 md:px-10 py-2.5 md:py-3 max-h-[64px] md:max-h-none">
        {/* Logo with tagline - Mobile Optimized */}
        <Link to="/" className="flex flex-col min-w-0 flex-shrink">
          <span className="text-[20px] md:text-2xl font-bold whitespace-nowrap leading-[1.1] text-light-text-primary dark:text-brand-text-primary">
            Oakley
          </span>
          <span className="text-[12px] md:text-sm font-medium text-light-text-secondary dark:text-brand-text-secondary whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px] md:max-w-none">
            Experience Oakley Vision
          </span>
        </Link>

        {/* Navigation - Mobile Optimized */}
        <nav className="flex gap-2 md:gap-6 items-center text-[16px] md:text-[16px] font-medium flex-shrink-0">
          <ThemeToggle size="md" className="mr-1 md:mr-2" />
          <NavLink to="/catalog" className={navClass}>
            Catalog
          </NavLink>
          <NavLink to="/cart" className={navClass} aria-label="View Cart">
            <div className="relative inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 md:w-5 md:h-5"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.5 9.75v-1.5A4.5 4.5 0 0012 3.75v0a4.5 4.5 0 00-4.5 4.5v1.5m0 0H4.125a.375.375 0 00-.375.375v.75c0 1.726.27 3.449.802 5.115l.913 2.856A3.375 3.375 0 008.754 21h6.492a3.375 3.375 0 003.289-2.904l.913-2.856a17.978 17.978 0 00.802-5.115v-.75a.375.375 0 00-.375-.375H7.5z"
                />
              </svg>
              <CartBadge count={cartCount} animate={true} />
            </div>
          </NavLink>
          {isAuthenticated && user?.role === 'admin' && (
            <>
              <NavLink to="/admin" className={navClass}>
                Admin
              </NavLink>
              <button 
                onClick={handleLogout} 
                className="text-light-text-primary dark:text-brand-text-primary hover:text-light-accent-red dark:hover:text-brand-accent-red transition min-h-[44px] px-2"
              >
                Logout
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
